import React from "react";
import PropTypes from "prop-types";
import MaterialButton from "@material-ui/core/Button";
import classNames from "classnames";
import {withStyles} from "@material-ui/core";

const materialStyles = {
  "large": {
    fontSize: `20px`,
    padding: `14px 28px`,
    lineHeight: `1.4`
  },
  "medium": {
    fontSize: `15px`,
    padding: `8px 16px`,
    lineHeight: `1.6`
  },
  "small": {
    fontSize: `13px`,
    padding: `2px 8px`,
    lineHeight: `1.54`,
    minWidth: `0`
  },
  "contained-primary": {
    "borderRadius": `5px`,
    "color": `#fff`,
    "backgroundColor": `#3cb868`,
    "textTransform": `none`,
    "&:hover": {
      backgroundColor: `#3aad64`,
      color: `#fff`,
      textDecoration: `none`
    },
    "&:focus": {
      backgroundColor: `#3aad64`,
      color: `#fff`,
      textDecoration: `none`
    },
    "&:active": {
      backgroundColor: `#3aad64`,
      color: `#fff`,
      textDecoration: `none`
    }
  },
  "contained-secondary": {
    "borderRadius": `5px`,
    "color": `#2a3133`,
    "backgroundColor": `#f5f6f6`,
    "textTransform": `none`,
    "&:hover": {
      backgroundColor: `#eff1f1`,
      color: `#2a3133`,
      textDecoration: `none`
    },
    "&:focus": {
      backgroundColor: `#eff1f1`,
      color: `#2a3133`,
      textDecoration: `none`
    },
    "&:active": {
      backgroundColor: `#eff1f1`,
      color: `#2a3133`,
      textDecoration: `none`
    }
  },
  "contained-danger": {
    "borderRadius": `5px`,
    "backgroundColor": `#f44a36`,
    "color": `#fff`,
    "textTransform": `none`,
    "&:hover": {
      backgroundColor: `#eb4734`,
      color: `#fff`,
      textDecoration: `none`
    },
    "&:focus": {
      backgroundColor: `#eb4734`,
      color: `#fff`,
      textDecoration: `none`
    },
    "&:active": {
      backgroundColor: `#eb4734`,
      color: `#fff`,
      textDecoration: `none`
    }
  },
  "outlined-primary": {
    "borderRadius": `5px`,
    "color": `#2a3133`,
    "backgroundColor": `#fff`,
    "border": `1px solid #ebecec`,
    "textTransform": `none`,
    "&:hover": {
      borderColor: `#dfe0e0`,
      backgroundColor: `#fff`,
      textDecoration: `none`
    },
    "&:focus": {
      borderColor: `#dfe0e0`,
      backgroundColor: `#fff`,
      textDecoration: `none`
    },
    "&:active": {
      borderColor: `#dfe0e0`,
      backgroundColor: `#fff`,
      textDecoration: `none`
    }
  },
  "outlined-secondary": {
    "borderRadius": `5px`,
    "color": `#949899`,
    "backgroundColor": `#fff`,
    "border": `1px solid #ebecec`,
    "textTransform": `capitalize`,
    "&:hover": {
      borderColor: `#dfe0e0`,
      backgroundColor: `#fff`,
      color: `#2a3133`,
      textDecoration: `none`
    },
    "&:focus": {
      borderColor: `#dfe0e0`,
      backgroundColor: `#fff`,
      color: `#2a3133`,
      textDecoration: `none`
    },
    "&:active": {
      borderColor: `#dfe0e0`,
      backgroundColor: `#fff`,
      color: `#2a3133`,
      textDecoration: `none`
    }
  },
  "disabled": {
    "backgroundColor": `#f5f6f6 !important`,
    "cursor": `not-allowed !important`,
    "pointerEvents": `auto  !important`,
    "padding": `14px`,

    "&:hover": {
      color: `rgba(0, 0, 0, 0.26)`
    }
  }
};

function Button(props) {
  const {size, variant, style, children, classes, ...restProps} = props;
  return (
    <MaterialButton
      classes={{
        root: classNames(classes[size], classes[`${variant}-${style}`]),
        disabled: classes.disabled
      }}
      {...restProps}
    >
      {children}
    </MaterialButton>
  );
}

Button.defaultProps = {
  size: `medium`,
  variant: `outlined`,
  style: `primary`
};

Button.propTypes = {
  size: PropTypes.oneOf([`large`, `medium`, `small`]),
  variant: PropTypes.oneOf([`outlined`, `contained`]),
  style: PropTypes.oneOf([`primary`, `secondary`, `danger`]),
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.array
  ]),
  classes: PropTypes.object
};

export default withStyles(materialStyles)(Button);
